import { render, staticRenderFns } from "./Kia2023Ev6Disclosure.vue?vue&type=template&id=831c16e6&"
import script from "./Kia2023Ev6Disclosure.vue?vue&type=script&lang=js&"
export * from "./Kia2023Ev6Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports